export default __webpack_public_path__ + "static/media/Login-background-mobile.5fd6db04.webp";